import { alpha, Chip, TableCell } from "@mui/material";
import CircularSectorProgress from "~/pages/integrations/security-pipeline/security-pipeline-github/SecurityPipelineGithubSpacePage/components/SecurityPipelineGithubPageTabs/SecurityPipelineGithubPageTabOverview/CircularSectorProgress";
import { useColorMode } from "~/providers/color-mode";

export type StatusCellVariant = "default" | "success" | "error";

interface StatusCellProps {
  label: string;
  progress: number;
  size?: number;
  variant?: StatusCellVariant;
  onClick?: () => void;
}

export const StatusCell = ({
  label,
  progress,
  size = 12,
  variant = "default",
  onClick,
}: StatusCellProps) => {
  const { mode } = useColorMode();
  const isLightMode = mode === "light";

  const variantRelatedProps = {
    ...(variant === "default"
      ? {
          backgroundColor: isLightMode ? "#000" : "#fff",
          color: isLightMode ? "#fff" : "#000",
          "&:hover": {
            backgroundColor: isLightMode
              ? alpha("#000", 0.5)
              : alpha("#fff", 0.5),
          },
        }
      : {}),
    ...(variant === "success"
      ? {
          backgroundColor: "success.main",
          color: "success.contrastText",
          "&:hover": {
            backgroundColor: "success.light",
          },
        }
      : {}),
    ...(variant === "error"
      ? {
          backgroundColor: "error.main",
          color: "error.contrastText",
          "&:hover": {
            backgroundColor: "error.light",
          },
        }
      : {}),
  };

  return (
    <TableCell>
      <Chip
        label={label}
        icon={<CircularSectorProgress size={size} progress={progress} />}
        size="small"
        sx={{
          px: 1,
          py: 0.5,
          borderRadius: 2,
          fontSize: 12,
          fontWeight: "700",
          ...variantRelatedProps,
        }}
        onClick={(e) => {
          e.preventDefault();
          onClick?.();
        }}
      />
    </TableCell>
  );
};
